import { render, staticRenderFns } from "./FaturasPage.vue?vue&type=template&id=1877f65c&"
import script from "./FaturasPage.vue?vue&type=script&lang=js&"
export * from "./FaturasPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports